/**
 * ???? ????(trade_policy) API ???? ????.
 *
 * ???? ????????? ?????????????? ???? ????/????.
 * HQ(????) ?????? ????? API.
 *
 * axios ??????????(src/api/index.js)?????????? ????????,
 * ??? ????? index.js????????????????? ???????? Authorization ???????????????.
 */
import api from './index'

/* ================================================================
 * ???? ???? API
 * ================================================================ */

/**
 * ???? ???? ?? ???? (??????????+ ?????).
 * HQ ?????? ?????.
 *
 * @param {Object} params - { spotType, tradeSide, activeYn, page, size }
 * @returns {Promise} { data: { items, total, page, size, totalPages }, code, message }
 */
export function getTradePolicyList(params) {
  return api.get('/api/v1/trade-policy', { params })
}

/**
 * ???? ???? ????? ????.
 * HQ ?????? ?????.
 *
 * @param {string} tradePolicyCode - ?????????
 * @returns {Promise} { tradePolicyCode, policyName, spotType, tradeSide, ... }
 */
export function getTradePolicyDetail(tradePolicyCode) {
  return api.get(`/api/v1/trade-policy/${tradePolicyCode}`)
}

/**
 * ???? ???? ???? (HQ ?????? ?????).
 *
 * @param {string} tradePolicyCode - ???????????????
 * @param {Object} data - ???? ??? body (updateTradePolicyRequest)
 * @returns {Promise} ?????????? ????? ?????
 */
export function updateTradePolicy(tradePolicyCode, data) {
  return api.put(`/api/v1/trade-policy/${tradePolicyCode}`, data)
}
